import axios from '@/utils/request'
import { AxiosPromise } from 'axios'
import { BaseResponse, ResponseStatus } from '.'
import { RegionInfo } from '@/api/config'

export { BaseResponse, ResponseStatus }

export interface TournamentSearchIndex {
  tournamentId: string
  name: string
  about: string
  game: string
  regions: RegionInfo[]
  banner: string
  logo: string
}

export interface MemberSearchIndex {
  memberId: string
  nickname: string
}

export interface SearchResultResponse {
  tournaments: TournamentSearchIndex[]
  members: MemberSearchIndex[]
}

export class SearchAPI {
  public static API_PREFIX = '/search/v1'

  public static searchAll(
    query: string,
    page: number = 1
  ): AxiosPromise<BaseResponse<SearchResultResponse>> {
    return axios.get(`${this.API_PREFIX}/search`, {
      params: {
        q: query,
        page
      }
    })
  }

  public static searchTournaments(
    query: string,
    page: number = 1
  ): AxiosPromise<BaseResponse<TournamentSearchIndex[]>> {
    return axios.get(`${this.API_PREFIX}/search/tournaments`, {
      params: {
        q: query,
        page
      }
    })
  }
}
